import auth from '@/api/auth'
import router from "@/router";
import axios from '@/plugins/axios'
import { auth as firebaseAuth } from '@/plugins/firebase'
import {handleResponseError} from '@/api/handleError'
import { get } from 'lodash'

const state = () => ({
  user: {},
  logoutError: '',
  resetPassword: '',
  profileUpdate: {}
})

const getters = {
  isAuthenticated() {
    const firebaseToken = localStorage.getItem('firebaseToken')
    return !!firebaseToken
  },
  accessToken() {
    return localStorage.getItem('accessToken')
  },
  user: state => state.user,
  permissions() {
    return JSON.parse(localStorage.getItem('permissions'))
  }
}

const actions = {
  async login({commit}, data) {
    const firebaseResult = await auth.loginFirebase(data.email, data.password)
    const firebaseToken = (await firebaseResult.user.getIdTokenResult()).token
    await commit('setFirebaseToken', firebaseToken)
    const result = await auth.loginApi(firebaseToken)
    const accessToken = result.data.token.access_token
    await commit('setAccessToken', accessToken)
    const user = result.data.user
    await commit('setLoggedUser', user)
  },
  async logout({commit}) {
    try {
      await auth.logoutApi();
      await firebaseAuth.signOut();
      commit('setLogout');
      router.push('/login');
    } catch (e) {
      commit('logoutError', handleResponseError(e));
    }
  },
  async getCurrentUser({commit}) {
    const res = await auth.getCurrentUser()
    if (get(res, 'data.user')) {
      await commit('setLoggedUser', res.data.user)
    }
  },
  async sendPasswordResetEmail({commit}, email) {
    const resetPasswordEmail = await auth.resetPasswordFirebase(email)
    commit('resetPassword', resetPasswordEmail)
  },
  async updateProfile({commit}, data) {
    const res = await auth.updateProfile(data)
    if (get(res, 'data.user')) {
      await commit('setLoggedUser', res.data.user)
    }
  },
  setLoggedUser({commit}, user) {
    commit('setLoggedUser', user)
  }
}

const mutations = {
  setFirebaseToken(state, token) {
    localStorage.setItem('firebaseToken', token)
  },
  setAccessToken(state, token) {
    localStorage.setItem('accessToken', token)
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
  },
  setLogout(state) {
    state.user = {}
    delete axios.defaults.headers.common['Authorization']
    localStorage.removeItem('firebaseToken')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('mini')
    localStorage.removeItem('darkTheme')
    localStorage.removeItem('permissions')
  },
  logoutError(state, message) {
    state.logoutError = message
  },
  resetPassword(state, result) {
    state.resetPassword = result
  },
  setLoggedUser(state, user) {
    state.user = user
    localStorage.setItem('permissions', JSON.stringify(user.permissions))
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
